<template>
    <div v-if="this.showMap">
        <gmap-map ref="map" :center="center" :zoom="zoom" class="g-map" @click="clickOnMap($event)">
            <gmap-marker v-for="(m, index) in markers" :key="index" :position="m.position" />
        </gmap-map>
    </div>
</template>

<script>
export default {
    name: 'selection-on-map',
    props: {
        latitude: Number,
        longitude: Number,
        zoom: Number,
        showMap: Boolean,
    },
    data() {
        return {
            center: { lat: this.latitude, lng: this.longitude },
            markers: [],
        }
    },
    watch: {
        latitude: function () {
            this.setCenter(this.latitude, this.longitude)
        },

        longitude: function () {
            this.setCenter(this.latitude, this.longitude)
        },
    },

    methods: {
        setCenter(latitude, longitude) {
            this.center = { lat: latitude, lng: longitude }
            this.addMarker(latitude, longitude)
        },

        addMarker(latitude, longitude) {
            const marker = {
                lat: latitude,
                lng: longitude,
            }
            this.markers = []
            this.markers.push({ position: marker })
        },
        isPlaceValid(place) {
            let count = 0
            place.address_components.forEach((component) => {
                if (
                    component.types.includes('locality') ||
                    component.types.includes('postal_town') || //English case
                    component.types.includes('country') ||
                    component.types.includes('postal_code') ||
                    component.types.includes('plus_code')
                ) {
                    count++
                }
            })
            return count >= 3
        },
        clickOnMap(event) {
            let geocoder = new window.google.maps.Geocoder()

            geocoder.geocode({ location: event.latLng }, (results, status) => {
                if (status === 'OK') {
                    if (results[0] && this.isPlaceValid(results[0])) {
                        this.$emit('getDomicileFromGeocode', results[0])
                    } else {
                        this.showSnackbar('warning', this.$t('asset_domicile.bad_marker'))
                    }
                } else {
                    this.manageError('error', this.$t('asset_domicile.error_geocode'))
                }
            })

            this.addMarker(event.latLng.lat(), event.latLng.lng())
        },
    },
}
</script>

<style scoped>
.g-map {
    width: 100%;
    height: 400px;
    margin-bottom: 20px;
}
</style>
